<script>

import Vue from 'vue'
import Fragment from 'vue-fragment'

// @ is an alias to /src
import VueSweetalert2 from 'vue-sweetalert2'
import MixinIcon from '@/mixins/MixinIcon'
import 'sweetalert2/dist/sweetalert2.min.css'
import Snackbar from '@/components/Snackbar'
import {useAuthenticationStore} from '@/stores/AuthenticationStore'
import {useCategoriesStore} from "@/stores/CategoriesStore";
import {useGroupsStore} from "@/stores/GroupsStore";
import {useRulesStore} from "@/stores/RulesStore";
import {useUsersStore} from "@/stores/UsersStore";
import {useInformationStore} from "@/stores/InformationStore";
import {usePhonesStore} from "@/stores/PhonesStore";
import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import {useProgressBarsStore} from "@/stores/ProgressBarStore";
import {useLoginStore} from "@/stores/LoginStore";


Vue.use(VueSweetalert2)
Vue.use(Fragment.Plugin)

export default {
    name: 'Authentication',
    mixins: [MixinIcon],
    components: {
        Snackbar
    },
    mounted() {

        let self = this

        const authenticationStore = useAuthenticationStore()
        authenticationStore.logout()
        self.$router.push({name: 'Login'})
    },

}
</script>
